import React from "react";
import ConfirmDialog from "./ConfirmDialog";
import { Snackbar } from "@mui/material";
import { LoadingOverlay } from "./LoadingOverlay";

export default function SnpComponent(props) {

  const {
    showDialog = false,
    outSideClickDismiss = true,
    handleSubmit = () => { },
    title = "",
    subTitle = "",
    negativeAction = "",
    positiveReq = false,
    positiveAction = "",
    handleDialogClose = () => { },
    isLoader = false,
    iconReq = "",
    iconContent = "",
    content = "",
    snackBarOpen = false,
    snackBarMsg = "",
    snackDuration = 3000,
    onSnackClose = () => { },
    negativeReq = false,
    cancelExtra = false,
    onCancel = () => { },
    // children,
  } = props;

  const handleSnackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if (onSnackClose)
      onSnackClose(event);
  };

  const onDialogClose = (event) => {
    //console.log("onDialogClose",outSideClickDismiss);
    if (outSideClickDismiss && handleDialogClose) {
      handleDialogClose(event);
    }
  };


  return (
    <div>
      <LoadingOverlay loading={isLoader} label="Loading...">
        {content}
      </LoadingOverlay>
      {
        showDialog && <ConfirmDialog isOpen={showDialog}
          title={title}
          subTitle={subTitle}
          negativeReq={negativeReq}
          negativeAction={negativeAction}
          positiveReq={positiveReq}
          positiveAction={positiveAction}
          onClose={onDialogClose}
          iconReq={iconReq}
          iconContent={iconContent}
          onSubmit={handleSubmit}
          cancelExtra={cancelExtra}
          onCancel={onCancel}
        />
      }
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={3000}
        message={snackBarMsg}
        onClose={handleSnackClose}
      />
    </div>
  );
};